<template>
    <div class="push-scheme-container">
        <span class="title-description">方案名称只在内部系统做方案表示，不对外显示</span>
        <el-form :model="pushSchemeForm" ref="form">
            <el-form-item prop="push_plan_name" 
            :rules="[{
                required: true, message: ' ', trigger: ['blur', 'change']
            }]">
                <sub-inputtrim size="small" v-model="pushSchemeForm.push_plan_name" :disabled="isDetail"></sub-inputtrim>
            </el-form-item>
            <el-button class="next-button" type="primary" size="small" @click="handlerNext" v-if="!isDetail">下一步</el-button>
        </el-form>
    </div>
</template>
<script>
import { mapState } from "vuex";
export default {
    name: 'push-scheme',
    data() {
        return {
            pushSchemeForm: {
                push_plan_name: ''
            },
        }
    },
    props: ['isDetail', 'isCopy'],
    computed: {
        ...mapState('pushPushPlanOperate', ['data']),
    },
    watch: {
        data: {
            handler() {
                if(this.data.push_plan_name) {
                    this.pushSchemeForm.push_plan_name = this.isCopy ? 'copy of ' + this.data.push_plan_name : this.data.push_plan_name 
                }
            },
            deep: true 
        }
    },
    methods: {
        handlerNext() {
            this.$refs['form'].validate((valid) => {
                if(valid) {
                     this.$emit('submit', this.pushSchemeForm, 'scheme')
                }
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// website/subComponents/push/PushScheme.vue